import hexColor from './hexColor';

export default {
    hexColor
};
